import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/RawMatActions/';

export default {
  getRawMatActions: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
};
